import React from 'react';
import { Typography } from '@mui/material';
import { string } from 'prop-types';

import staticText from '../../localization/Legal/disclaimer';

const Disclaimer = ({ text }) => {
  return (
    <Typography variant="caption" component="p" sx={{ marginTop: 2 }}>
      {text}
    </Typography>
  );
};

export default Disclaimer;

Disclaimer.propTypes = {
  text: string,
};

Disclaimer.defaultProps = {
  text: staticText.legalDisclaimer,
};
